import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Guardian } from '@xaamin/guardian';
import { Button, Row, Col } from 'react-bootstrap';

import SociosDeNegocioList from './list/SociosDeNegocioList';
import SociosDeNegocioSearch from './list/components/SociosDeNegocioSearch';
import SociosDeNegocioListItemActions from './list/SociosDeNegocioListItemActions';

class SociosDeNegocio extends Component {

  state = {
    selectedRowKeys: [],
    selectedRows: []
  }

  componentDidMount() {
    window.setAppTitle('SociosDeNegocio');
  }

  handleOnRowSelectionChange = ({selectedRowKeys, selectedRows}) => {
    this.setState({
      selectedRowKeys,
      selectedRows
    });
  }

  handleOnRowClick = (data) => {
    this.props.history.replace({
      pathname: `/modulos/socios/${data.id}/info`,
      state: {
        data: {...data}
      }
    });
  }

  render() {
    const { selectedRowKeys, selectedRows } = this.state;

    return (
      <div>
        <Row className="mb-3">
          <Col sm="12" md="9">
            { selectedRowKeys.length === 0 && <SociosDeNegocioSearch /> }

            { selectedRowKeys.length > 0 && (
                <SociosDeNegocioListItemActions
                  selectedRowKeys={ selectedRowKeys }
                  selectedRows={ selectedRows }
                />
              )
            }
          </Col>
          { Guardian.allows('socios.negocio.crear') && (
            <Col sm="12" md="3" className="text-right">
              <Link to="/modulos/socios/registrar" className="mr-3">
                <Button>
                  Nuevo Socio
                </Button>
              </Link>
            </Col>
          )}
        </Row>

        { Guardian.allows('socios.negocio.listar') && (
          <SociosDeNegocioList
            onRowClick={ this.handleOnRowClick }
            onRowSelectionChange={ this.handleOnRowSelectionChange }
          />
        )}
      </div>
    )
  }
}

export default SociosDeNegocio;